import SiteLayout from '@/components/feature/SiteLayout';
import SectionHeading from '@/components/feature/SectionHeading';
import EventCard from '@/components/feature/EventCard';
import CategoryGrid from './components/CategoryGrid';
import HeroCarousel from './components/HeroCarousel';
import HotRanking from './components/HotRanking';
import TopicSection from './components/TopicSection';
import { events } from '@/mocks/events';
import { categories } from '@/mocks/categories';
import { getFeaturedEvents, getHotEvents, getLatestEvents, formatViews } from '@/utils/news';
import { Link } from 'react-router-dom';

export default function Home() {
  const featured = getFeaturedEvents(5);
  const latest = getLatestEvents(8);
  const hot = getHotEvents(5);
  const totalViews = events.reduce((sum, e) => sum + e.views, 0);
  const tagPool = ['总决赛', '街舞', '带货', '公益', '连麦', '国风', '素人', '助农'];

  return (
    <SiteLayout>
      <HeroCarousel items={featured} />

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <section>
          <SectionHeading
            title="赛事分类快捷入口"
            subtitle="按你感兴趣的赛事类型，快速找到对应的最新资讯"
            icon="ri-apps-2-line"
            moreTo="/category/all"
            moreLabel="全部赛事"
          />
          <CategoryGrid />
        </section>

        <section className="mt-12 md:mt-16">
          <SectionHeading
            title="最新赛事资讯"
            subtitle="每日更新，第一时间掌握网红大赛的最新动态"
            icon="ri-newspaper-line"
            moreTo="/category/all"
          />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {latest.map((e, i) => (
              <EventCard key={e.id} event={e} index={i} />
            ))}
          </div>
        </section>

        <section className="mt-12 md:mt-16">
          <SectionHeading
            title="热门赛事推荐"
            subtitle="基于浏览量与编辑精选，为你呈现本周最值得关注的赛事"
            icon="ri-fire-line"
          />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
            <div className="lg:col-span-2">
              <HotRanking items={hot} />
            </div>
            <aside className="flex flex-col gap-5">
              <div className="rounded-lg border border-background-200 bg-primary-50 p-5">
                <h3 className="font-heading font-bold text-base text-foreground-950 mb-4 flex items-center gap-2">
                  <i className="ri-bar-chart-box-line text-primary-600"></i>
                  赛事数据速览
                </h3>
                <div className="grid grid-cols-3 gap-3 text-center">
                  <div>
                    <p className="font-heading font-extrabold text-xl text-primary-600">{events.length}</p>
                    <p className="text-xs text-foreground-600 mt-1">赛事报道</p>
                  </div>
                  <div>
                    <p className="font-heading font-extrabold text-xl text-primary-600">{categories.length}</p>
                    <p className="text-xs text-foreground-600 mt-1">赛事类型</p>
                  </div>
                  <div>
                    <p className="font-heading font-extrabold text-xl text-primary-600">
                      {formatViews(totalViews)}
                    </p>
                    <p className="text-xs text-foreground-600 mt-1">总阅读量</p>
                  </div>
                </div>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <h3 className="font-heading font-bold text-base text-foreground-950 mb-3 flex items-center gap-2">
                  <i className="ri-hashtag text-accent-500"></i>
                  热门标签
                </h3>
                <div className="flex flex-wrap gap-2">
                  {tagPool.map((tag) => (
                    <Link
                      key={tag}
                      to={`/search?q=${encodeURIComponent(tag)}`}
                      className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium hover:bg-accent-100 hover:text-accent-900 transition-colors"
                    >
                      #{tag}
                    </Link>
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </section>

        <section className="mt-12 md:mt-16">
          <SectionHeading
            title="本周热门专题合集"
            subtitle="聚合热门话题，一次看遍精彩内容"
            icon="ri-bookmark-3-line"
          />
          <TopicSection />
        </section>

        <section className="mt-12 md:mt-16 rounded-lg border border-background-200 bg-secondary-100 p-6 md:p-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6 justify-between">
            <div className="max-w-2xl">
              <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950">
                关于每日大瓜网红大赛百度
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                我们专注网红大赛领域的资讯聚合与内容策划，涵盖网红歌唱赛、舞蹈赛、直播PK赛、带货赛、才艺挑战赛与公益主播赛等多元赛事类型，为热爱网红圈热点信息的年轻群体提供全面、及时、准确的赛事报道与精彩回顾。搜索、分类筛选与专题内容每日更新。
              </p>
            </div>
            <Link
              to="/about"
              className="shrink-0 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}